<template>
  <div style="max-width: 450px;" class="flex-1 flex flex-col p-5">
    <div v-if="props.logo" class="p-6 flex justify-center mb-12">
      <a href="https://tickable.nl/">
        <img :src="isDark ? whiteLogo : darkLogo" alt="Tickable" style="width: 150px;" />
      </a>
    </div>
    <div class="w-full">
      <div class="flex gap-2 items-center mb-4 justify-content-cente">
        <div class="flex items-center justify-center bg-red-100 rounded-border"
          style="width:2.5rem;height:2.5rem">
          <i class="pi pi-exclamation-triangle text-red-500 text-xl"></i>
        </div>
        <h1 class="text-surface-900 dark:text-surface-0 font-semibold text-xl">{{ t('error_occurred') }}</h1>
      </div>
      <p class="text-lg text-surface-600 dark:text-surface-200">
        {{ t('error_code') }}: {{ error?.statusCode }} - {{ error?.message ?? error?.error }}
      </p>
      <div class="pb-6">
        <p>{{ t('error_reported') }}</br></br> {{ t('error_steps_intro') }}</p>
        <ul class="flex flex-col gap-2 mt-4">
          <li>{{ t('error_step_browser') }}</li>
          <li>{{ t('error_step_clear_data') }}</li>
          <li>{{ t('error_step_connection') }}</li>
        </ul>
      </div>

      <!-- A full page load, not a NuxtLink: after a deploy the old build's chunks
           are gone, and staying inside that app only fails again. -->
      <a href="/">
        <Button :label="t('retry')" class="w-full" type="submit" rounded />
      </a>
      <NuxtLink to="https://tickable.nl/contact/" target="_blank">
        <Button :label="t('contact_us')" text class="w-full mt-2" type="submit" rounded />
      </NuxtLink>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useDark } from '@vueuse/core'
import { NuxtError } from '#app';
import darkLogo from '~/assets/img/tickable-logo.svg'
import whiteLogo from '~/assets/img/tickable-logo-wit.svg'


const { t } = useI18n();
const isDark = useDark();
const props = defineProps({
  error: Object as () => Partial<NuxtError & { error?: string | Error }> | any,
  logo: Boolean
})
onMounted(() => {
  console.error(props.error?.error);
  //@ts-ignore
  console.error(props.error?.error?.['value']);
})


</script>

<style></style>